module.exports = __webpack_public_path__ + "static/media/logo_qadra_dark.c19da893.png";